import { AuthRoutes } from '@xarvio/frontend-core-router/lib/AuthRoutes';

export interface PublicAuthUrlsInput {
  country?: string;
  locale?: string;
}

const getPrefix = ({ country, locale }: PublicAuthUrlsInput) => {
  if (country && locale) return `/${country}/${locale}`;
  if (country) return `/${country}`;
  if (locale) return `/${locale}`;
  return '';
};

export const getPublicAuthUrls = (input: PublicAuthUrlsInput) => {
  const prefix = getPrefix(input);

  return {
    loginPageUrl: `${prefix}/${AuthRoutes.LOGIN}`,
    registrationPageUrl: `${prefix}/${AuthRoutes.REGISTRATION}`,
    autoLoginPageUrl: `${prefix}/${AuthRoutes.AUTO_LOGIN}`,
    forgotPasswordPageUrl: `${prefix}/${AuthRoutes.FORGOT_PASSWORD}`,
    resetPasswordPageUrl: `${prefix}/${AuthRoutes.RESET_PASSWORD}`,
    emailVerifiedPageUrl: `${prefix}/${AuthRoutes.EMAIL_VERIFIED}`,
    acceptTermsAndConditionsPageUrl: `${prefix}/${AuthRoutes.ACCEPT_TC}`,
    smartSprayerLandingPageUrl: `${prefix}/${AuthRoutes.SMART_SPRAYER_LANDING}`,
    smartSprayerRegistrationPageUrl: `${prefix}/${AuthRoutes.SMART_SPRAYER_REGISTRATION}`,
  };
};
